import React, { Component } from "react";
import { Steps } from "antd";
import { injectIntl } from "react-intl";

class UploadStepper extends Component {
  render() {
    const { currentStep, intl } = this.props;
    return (
      <Steps
        current={currentStep}
        labelPlacement="vertical"
        style={{
          overflowX: "auto",
          paddingLeft: "5%",
          paddingRight: "5%"
        }}
      >
        <Steps.Step title={intl.formatMessage({ id: "upload-folder-step1" })} />
        <Steps.Step title={intl.formatMessage({ id: "upload-folder-step2" })} />
        <Steps.Step title={intl.formatMessage({ id: "upload-folder-step3" })} />
        <Steps.Step title={intl.formatMessage({ id: "upload-folder-step4" })} />
      </Steps>
    );
  }
}

export default injectIntl(UploadStepper);
